import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  questions: {
    '&.isAnswering': {
      ...mixins.noClickableFilter,
    },

    '&.withMinHeight': {
      minHeight: '80px',

      '@media screen and (min-width: 1500px)': {
        minHeight: '102px',
      },
    },

    '& > .draggable': {
      '&:first-child': {
        '&, & > .question': {
          borderRadius: '4px 4px 0 0',
        },
      },

      '&:last-child': {
        '&, & > .question': {
          borderRadius: '0 0 4px 4px',
        },
      },
    },
  },
}));

export default useStyles;
